/**
 * Escrituras de la lección elder-2 (liderazgo servicial). Texto según churchofjesuschrist.org.
 */
import type { Scripture } from './scriptures';

export const elder2TrainingScripturesEs: Scripture[] = [
  {
    id: 'dc-121-34-46',
    reference: 'Doctrina y Convenios 121:34–46',
    text:
      'He aquí, muchos son los llamados, y pocos los escogidos. ¿Y por qué no son escogidos? Porque a tal grado han puesto su corazón en las cosas de este mundo, y aspiran tanto a los honores de los hombres, que no aprenden esta lección única: Que los derechos del sacerdocio están inseparablemente unidos a los poderes del cielo, y que estos no pueden ser gobernados ni manejados sino conforme a los principios de la rectitud. Es cierto que se nos pueden conferir; pero cuando intentamos encubrir nuestros pecados, o satisfacer nuestro orgullo, nuestra vana ambición, o ejercer mando, dominio o compulsión sobre las almas de los hijos de los hombres, en cualquier grado de injusticia, he aquí, los cielos se retiran, el Espíritu del Señor es ofendido, y cuando se aparta, se acabó el sacerdocio o autoridad de tal hombre. He aquí, antes que se dé cuenta, queda abandonado a sí mismo para dar coces contra el aguijón, para perseguir a los santos y combatir contra Dios. Hemos aprendido, por tristes experiencias, que la naturaleza y disposición de casi todos los hombres, en cuanto reciben un poco de autoridad, como ellos suponen, es comenzar inmediatamente a ejercer injusto dominio. Por tanto, muchos son llamados, pero pocos son escogidos. Ningún poder o influencia se puede ni se debe mantener en virtud del sacerdocio, sino por persuasión, por longanimidad, benignidad, mansedumbre y por amor sincero; por bondad y por conocimiento puro, lo cual engrandecerá en gran manera el alma sin hipocresía y sin malicia; reprendiendo en el momento oportuno con severidad, cuando lo induzca el Espíritu Santo; y entonces demostrando mayor amor hacia el que has reprendido, no sea que te considere su enemigo; para que sepa que tu fidelidad es más fuerte que los lazos de la muerte. Deja también que tus entrañas se llenen de caridad para con todos los hombres, y para con los de la familia de la fe, y deja que la virtud engalane tus pensamientos incesantemente; entonces tu confianza se fortalecerá en la presencia de Dios; y la doctrina del sacerdocio destilará sobre tu alma como rocío del cielo. El Espíritu Santo será tu compañero constante, y tu cetro, un cetro inmutable de justicia y de verdad; y tu dominio será un dominio eterno, y sin ser compelido fluirá hacia ti para siempre jamás.',
    verses: [
      {
        verse: 34,
        text: 'He aquí, muchos son los llamados, y pocos los escogidos. ¿Y por qué no son escogidos?',
      },
      {
        verse: 35,
        text: 'Porque a tal grado han puesto su corazón en las cosas de este mundo, y aspiran tanto a los honores de los hombres, que no aprenden esta lección única:',
      },
      {
        verse: 36,
        text: 'Que los derechos del sacerdocio están inseparablemente unidos a los poderes del cielo, y que estos no pueden ser gobernados ni manejados sino conforme a los principios de la rectitud.',
      },
      {
        verse: 37,
        text: 'Es cierto que se nos pueden conferir; pero cuando intentamos encubrir nuestros pecados, o satisfacer nuestro orgullo, nuestra vana ambición, o ejercer mando, dominio o compulsión sobre las almas de los hijos de los hombres, en cualquier grado de injusticia, he aquí, los cielos se retiran, el Espíritu del Señor es ofendido, y cuando se aparta, se acabó el sacerdocio o autoridad de tal hombre.',
      },
      {
        verse: 38,
        text: 'He aquí, antes que se dé cuenta, queda abandonado a sí mismo para dar coces contra el aguijón, para perseguir a los santos y combatir contra Dios.',
      },
      {
        verse: 39,
        text: 'Hemos aprendido, por tristes experiencias, que la naturaleza y disposición de casi todos los hombres, en cuanto reciben un poco de autoridad, como ellos suponen, es comenzar inmediatamente a ejercer injusto dominio.',
      },
      {
        verse: 40,
        text: 'Por tanto, muchos son llamados, pero pocos son escogidos.',
      },
      {
        verse: 41,
        text: 'Ningún poder o influencia se puede ni se debe mantener en virtud del sacerdocio, sino por persuasión, por longanimidad, benignidad, mansedumbre y por amor sincero;',
      },
      {
        verse: 42,
        text: 'por bondad y por conocimiento puro, lo cual engrandecerá en gran manera el alma sin hipocresía y sin malicia;',
      },
      {
        verse: 43,
        text: 'reprendiendo en el momento oportuno con severidad, cuando lo induzca el Espíritu Santo; y entonces demostrando mayor amor hacia el que has reprendido, no sea que te considere su enemigo;',
      },
      {
        verse: 44,
        text: 'para que sepa que tu fidelidad es más fuerte que los lazos de la muerte.',
      },
      {
        verse: 45,
        text: 'Deja también que tus entrañas se llenen de caridad para con todos los hombres, y para con los de la familia de la fe, y deja que la virtud engalane tus pensamientos incesantemente; entonces tu confianza se fortalecerá en la presencia de Dios; y la doctrina del sacerdocio destilará sobre tu alma como rocío del cielo.',
      },
      {
        verse: 46,
        text: 'El Espíritu Santo será tu compañero constante, y tu cetro, un cetro inmutable de justicia y de verdad; y tu dominio será un dominio eterno, y sin ser compelido fluirá hacia ti para siempre jamás.',
      },
    ],
    context: 'Poder del sacerdocio solo por rectitud; persuasión, caridad y compañía del Espíritu.',
  },
  {
    id: 'john-13-14-15',
    reference: 'Juan 13:14–15',
    text:
      'Pues si yo, el Señor y el Maestro, he lavado vuestros pies, vosotros también debéis lavaros los pies los unos a los otros. Porque ejemplo os he dado, para que así como yo os he hecho, vosotros también hagáis.',
    verses: [
      {
        verse: 14,
        text: 'Pues si yo, el Señor y el Maestro, he lavado vuestros pies, vosotros también debéis lavaros los pies los unos a los otros.',
      },
      {
        verse: 15,
        text: 'Porque ejemplo os he dado, para que así como yo os he hecho, vosotros también hagáis.',
      },
    ],
    context: 'Jesús enseña el servicio con el ejemplo del lavado de pies.',
  },
  {
    id: 'dc-107-99-100',
    reference: 'Doctrina y Convenios 107:99–100',
    text:
      'Por tanto, aprenda todo varón su deber, así como a obrar con toda diligencia en el oficio al cual fuere nombrado. El que sea perezoso no será considerado digno de permanecer, y quien no aprenda su deber y no se presente aprobado, no será considerado digno de permanecer. Así sea. Amén.',
    verses: [
      {
        verse: 99,
        text: 'Por tanto, aprenda todo varón su deber, así como a obrar con toda diligencia en el oficio al cual fuere nombrado.',
      },
      {
        verse: 100,
        text: 'El que sea perezoso no será considerado digno de permanecer, y quien no aprenda su deber y no se presente aprobado, no será considerado digno de permanecer. Así sea. Amén.',
      },
    ],
    context: 'Aprender el deber y obrar con diligencia en el oficio conferido.',
  },
  {
    id: 'alma-17-11',
    reference: 'Alma 17:11',
    text:
      'Y les dijo también el Señor: Id entre los lamanitas, vuestros hermanos, y estableced mi palabra; empero seréis pacientes en las congojas y aflicciones, para que les deis buenos ejemplos en mí; y os haré instrumentos en mis manos, para la salvación de muchas almas.',
    verses: [
      {
        verse: 11,
        text: 'Y les dijo también el Señor: Id entre los lamanitas, vuestros hermanos, y estableced mi palabra; empero seréis pacientes en las congojas y aflicciones, para que les deis buenos ejemplos en mí; y os haré instrumentos en mis manos, para la salvación de muchas almas.',
      },
    ],
    context: 'Paciencia y buen ejemplo en la obra misional entre los lamanitas.',
  },
  {
    id: 'dc-58-27',
    reference: 'Doctrina y Convenios 58:27',
    text:
      'De cierto digo que los hombres deben estar anhelosamente consagrados a una causa buena, y hacer muchas cosas de su propia voluntad y efectuar mucha justicia;',
    verses: [
      {
        verse: 27,
        text: 'De cierto digo que los hombres deben estar anhelosamente consagrados a una causa buena, y hacer muchas cosas de su propia voluntad y efectuar mucha justicia;',
      },
    ],
    context: 'Agencia y dedicación a la obra justa sin esperar solo mandamiento.',
  },
];
